/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/opt'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Business from '@routes/Business';

export const Route = createFileRoute('/opt')({
  component: () => <CacheDataRoute component={Business} path='/opt' />
});
